import { createFileRoute } from '@tanstack/react-router';

import { PlatformOrganizationListScreen } from '@/features/organizations/components/platform/OrganizationListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/organizations/')({
  beforeLoad: () => {
    requirePermission('org:read');
  },
  component: PlatformOrganizationListScreen,
  staticData: { crumb: 'Organizations' },
});
